import { Link } from "react-router-dom";
import { categories } from "@/mocks/leaks";
import { site } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="mt-20 bg-secondary-950 text-secondary-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {site.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-200/85">
              {site.intro}
            </p>
            <p className="mt-4 text-xs text-secondary-300/70">
              站内涉及的事件与人物均为虚构，请勿对号入座。
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50">站内导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="transition-colors hover:text-primary-200">首页</Link>
              </li>
              <li>
                <Link to="/feed" className="transition-colors hover:text-primary-200">最新爆料</Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-200">关于我们</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-primary-200">联系投稿</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50">主题分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm md:grid-cols-1">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/topic/${cat.slug}`}
                    className="transition-colors hover:text-primary-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400" />
                <span className="break-all">{site.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-send-plane-line mt-0.5 text-base text-accent-400" />
                <span>爆料投稿请走专门入口</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 rounded-md border border-secondary-700 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:border-primary-400 hover:bg-primary-500"
            >
              前往投稿
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-2 px-4 py-5 text-xs text-secondary-300/80 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© {new Date().getFullYear()} 蝌蚪爆料 · 保留所有权利</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about" className="transition-colors hover:text-primary-200">内容原则</Link>
            <Link to="/contact" className="transition-colors hover:text-primary-200">投稿须知</Link>
            <span>本页信息仅供资讯参考</span>
          </p>
        </div>
      </div>
    </footer>
  );
}